export const SET_META_DATA = 'SET_META_DATA'
export const NEXT_STEP = 'NEXT_STEP'
export const PREVIOUS_STEP = 'PREVIOUS_STEP'
export const RESET_STEP = 'RESET_STEP'
export const RESET = 'RESET'
export const SET_ROLES_DATA = 'SET_ROLES_DATA'
export const ADD_ROLES_DATA = 'ADD_ROLES_DATA'
export const SET_EDITOR_MODE = 'SET_EDITOR_MODE'
export const SET_LAYOUT_VALUES = 'SET_LAYOUT_VALUES'
export const SET_LAYOUTS = 'SET_LAYOUTS'
export const SET_STATUS_BAR = 'SET_STATUS_BAR'
export const SET_SYSTEM_BAR = 'SET_SYSTEM_BAR'
export const SET_ID = 'SET_ID'
export const SET_SCREEN_SIZE = 'SET_SCREEN_SIZE'
export const SET_IS_EDITOR_MODE = 'SET_IS_EDITOR_MODE'